import Axios from "axios";
import React, { Component } from "react";

export default class TableInsumos extends Component{

    constructor(props) {
        super(props);

        this.state = {
            data: [],

            padroesAndSlugs: [
                {
                    padrao: "Padrão",
                    slug: "padrao"
                },
                {
                    padrao: "Classe",
                    slug: "classe"
                },
                {
                    padrao: "Discriminação do insumo",
                    slug: "discriminacao"
                },
                {
                    padrao: "Tipo",
                    slug: "tipo"
                },

            ]
        }


    }

    componentDidMount = async () => {
        try{
            let response = await Axios.get( route('web.supplies.family', {per_page: 200}) );

            if(response.status == 200){
                console.log(response.data);

                await this.setState({
                    ...this.state,
                    data: response.data.data
                })
            }
        }catch (e) {
            console.log(e);
        }
    }

    download = async () => {
        try{
            
            let response = await Axios.get( route('web.supplies.family', {format: 'excel', per_page: 200}));            

            if (response.status == 200) {
                if( response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ){
                    const type = response.headers['content-type']
                    const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'insumos.xlsx'
                    link.click()
                    
                }
            }
        }catch (e) {
            console.log(e);
        }
    }

    render(){

        return(
            <div>
                <div className="table-btn-div">
                    {/* <button
                        className="btn btn-sm btn-round btn-filter btn-download"
                        style={{
                        marginTop: "15px",
                        backgroundColor: "#5B7537",
                        borderColor: "#5B7537",
                        }}
                        onClick={() => this.download() }
                    >
                        <i class="fa fa-download"></i>
                    </button> */}
                    <a
                        className="btn btn-sm btn-round btn-filter btn-download"
                        style={{
                            marginTop: "15px",
                            backgroundColor: "#5B7537",
                            borderColor: "#5B7537",
                        }}
                        role="button"
                        href="https://brain.hqssolucoes.com.br/insumos/familia_insumos.xlsx"
                        download
                    >
                        <i class="fa fa-download"></i>
                    </a>
                </div>
                <table className="table table-striped container">
                    <thead>

                        <tr style={styles.tr_header}>
                        <td colSpan={10} style={styles.tr_header_text}>por m<sup>2</sup> de construção</td>
                        </tr>

                        <tr style={styles.tr_title}>
                            {this.state.padroesAndSlugs.map((padrao, index) => {
                                return <td key={index}>{padrao.padrao}</td>
                            })}
                        </tr>
                    </thead>

                    {this.state.data.map( (item, index) => {

                        return (
                            <tr key={`supplies_${index}_`}>
                                <td>{item.pattern}</td>
                                <td>{item.name}</td>
                                <td>{item.description}</td>
                                <td>{item.type}</td>
                            </tr>
                        )
                    })}

                </table>
            </div>
        );
    }

}

const styles = {
  tr_header: {
    backgroundColor: "#2e3525",
    color: "#fff",
    fontWeight: "bold",
  },
  tr_title: {
    backgroundColor: "#5b7537",
    color: "#fff",
    fontWeight: "bold"
  },
  tr_subtitle: {
    backgroundColor: "#7ca83e",
    color: "#fff",
    fontWeight: "bold"
  },
}